import { type MenuItems } from '@menu-lib/components/AppLayout/MainMenu/menuItems';

export type MenuItem = LinkItem | HeaderItem;

export type Target = '_top' | '_blank';

export interface LinkItem {
  itemtype: 'link';
  menuItem: MenuItems;
  route?: { name: string };
  title: string;
  url: string;
  iconclass: string;
  showbadge?: boolean;
  badgecontent?: string | number;
  target?: Target;
}

export interface HeaderItem {
  itemtype: 'header';
  menuItem: MenuItems;
  title: string;
}

export interface Tellingen {
  aantalSchades?: number;
  aantalAanvragen?: number;
  aantalMutatieAanvragen?: number;
  aantalPremievastellingen?: number;
  aantalMaatwerk?: number;
  spfMeldingen?: number;
}

export interface EnvironmentSettings {
  isMaatschappij: boolean;
  isInterneGebruiker: boolean;
  isFinancieel: boolean;
  isInstellingsRechten: boolean;
  isActiveAdviseur: boolean;
  heeftAdviseurbeheerRechten: boolean;
  heeftBeheerboxRechten: boolean;
  heeftRoyerenPermissie: boolean;
  heeftMutatieStartenPermissie: boolean;
  heeftVoorlopigeDekkingPermissie: boolean;
  tellingen?: Tellingen;
}

export const defaultTellingen: Tellingen = {
  aantalSchades: 0,
  aantalAanvragen: 0,
  aantalMutatieAanvragen: 0,
  aantalPremievastellingen: 0,
  aantalMaatwerk: 0,
  spfMeldingen: 0,
};

export interface MenuItemDefinition {
  isVisible(settings: EnvironmentSettings): boolean;
  create(settings: EnvironmentSettings): MenuItem;
}
